
class OrdersNotReceivedController {
    searchResult:Array<any>;
    activeSearchParams = {pageSize: 100, pageNo: 0, sort:""};

    searchDefinition ={
        fields:[
            {title:'Dato fra', name: 'deliveryDateFrom', type:'date'},
            {title:'Dato til', name: 'deliveryDateTo', type:'date'},
        ],
        fieldsLength: 15,
        searchFunction:(params)=> this.ordersNotReceivedSearch(params),
        searchParams: {pageNo: 0, pageSize: 100, toDate: this.$filter('date')(new Date, "yyyy-MM-dd") },
    };

    toolbarheaderDefinition = {
        isTable: true,
        toolbarHeading: "Søk etter ikke mottatte ordre",
        buttons: [
            {func: () => { this.searchDefinition.searchParams = {pageSize:100, pageNo: 0, toDate: this.$filter('date')(new Date, "yyyy-MM-dd")}}, tooltip: "Slett søkedata", materialicon: "delete_sweep"},
        ]
    };

    tableDefinition = {
        settings: {
            title: "Ikke mottatte ordre",
            initialPageSize: 100,
            onPaginate: (pageNo, pageSize)=> this.changePage(pageNo, pageSize),
            totalElements: null,
            promise: null
        },columns:[
            {title:'Dato', name: 'date', type: 'date', dateFormat: 'dd.MM.yyyy'},
            {title:'Varenummer', name: 'articleNo'},
            {title:'Vare', name: 'articleName'},
            {title:'Leverandørnummer', name: 'mainSupplierNo'},
            {title:'Leverandør', name: 'mainSupplierName'},
            {title:'Bekreftet', name: 'confirmed', type: 'number'}
        ]
    };
    constructor(private toastService, private $filter, private $mdDialog, private Prognosis, private $location){
        if($location.$$search.pageNo){
            this.searchDefinition.searchParams = $location.$$search;
        }else{
            this.searchDefinition.searchParams = {pageSize:100, pageNo: 0, toDate: this.$filter('date')(new Date, "yyyy-MM-dd")};
        }
    }

    $onInit() {
        this.$location.search(this.searchDefinition.searchParams);
    }

    changePage(pageNo, pageSize){
        this.activeSearchParams.pageNo = pageNo -1;
        this.activeSearchParams.pageSize = pageSize;
        this.$location.search(this.activeSearchParams);
    }

    ordersNotReceivedSearch(params){
        this.activeSearchParams = params;
        this.tableDefinition.settings.promise = this.Prognosis.searchNotReceived(params,{}).$promise.then(
            (results)=>{
                if(results.content.length === 0){
                    this.toastService.showSimpleToast("Søket gav ingen resultater", 2000);
                    this.searchResult = null;
                }
                else{
                    this.searchResult = results.content;
                    this.tableDefinition.settings.totalElements = results.totalElements;
                }
            },
            (error)=>this.toastService.parseError(error)
        );
    }
}

class NotReceivedOptions implements ng.IComponentOptions {
    controllerAs =  'c';
    public controller:string = "rkcOrdersNotReceivedController";
    public template: any = require('./ordersNotReceived.html');
}

rkcApp.controller("rkcOrdersNotReceivedController", ['toastService', '$filter', '$mdDialog', 'Prognosis', '$location', function(toastService, $filter, $mdDialog, Prognosis, $location){
    return new OrdersNotReceivedController(toastService, $filter, $mdDialog, Prognosis, $location);
}])
    .component("rkcNotReceived", new NotReceivedOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/ordersNotReceived/ordersNotReceived.ts
 **/